import { render } from "./presenters.vue?vue&type=template&id=5463724c&scoped=true"
import script from "./presenters.vue?vue&type=script&lang=js"
export * from "./presenters.vue?vue&type=script&lang=js"

import "./presenters.vue?vue&type=style&index=0&id=5463724c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5463724c"

export default script